import { Component, OnInit } from '@angular/core';
import { ContactUsMessage } from '../../models/contact-us-message';
import { DomSanitizer } from '@angular/platform-browser';
import { ContactUsMessagesService } from '../../services/contact-us-messages.service';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { Router } from '@angular/router';
import { UserService } from '../../../ProfileInfo/Services/UserProfileService';
import { IUserInfo } from '../../../ProfileInfo/Models/UserProfileModel';


@Component({
  selector: 'contact-us-message-reply',
  templateUrl: './contact-us-message-reply.component.html',
  styleUrls: ['./contact-us-message-reply.component.scss']
})
export class ContactUsMessageReplyComponent implements OnInit {
  model = {} as ContactUsMessage;
  admin: IUserInfo = {} as IUserInfo
  constructor(private route: Router,
    private diagRef: NbDialogRef<ContactUsMessageReplyComponent>,
    public sanitizer: DomSanitizer,
    private service: ContactUsMessagesService,
    private userService: UserService,
    private toast: NbToastrService) { }

  ngOnInit() {
    this.route.events.subscribe(() => {
      this.diagRef.close('false');
    });
    this.userService.getUser().subscribe((res) => {
      this.admin = res;
    });
  }



  close() {
    this.diagRef.close();
  }


  update() {
    this.model.messageStatus = 1;
    this.model.repliedBy = this.admin.name;
    return this.service.put(this.model.id, this.model)
      .subscribe({
        next: (res) => {
          this.diagRef.close('true');
          this.toast.show('تم تعديل المركز بنجاح', '', { status: 'success', duration: 3000 });
        },
        error: (err) => {
          this.diagRef.close('true');
          this.toast.danger('خطأ في تعديل المركز ', 'خطأ', { status: 'success', duration: 3000 });
        },
      });
  }


}


